/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SingleDeliveryNote } from '../../models/single-delivery-note';

export interface GetSingleDeliveryNoteMetaData$Params {
  deliveryNoteKey: KeyType;
}

export function getSingleDeliveryNoteMetaData(http: HttpClient, rootUrl: string, params: GetSingleDeliveryNoteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleDeliveryNote>> {
  const rb = new RequestBuilder(rootUrl, getSingleDeliveryNoteMetaData.PATH, 'get');
  if (params) {
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SingleDeliveryNote>;
    })
  );
}

getSingleDeliveryNoteMetaData.PATH = '/delivery-notes/{deliveryNoteKey}';
